import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Modal, IconButton, ToggleSwitch, Button } from "@toddle-edu/ds-web";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import { FormSelectDropdown } from "UIComponents/SelectDropdown";
import Loading from "UIComponents/Loading";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import { compose, graphql } from "lib/apolloClient";
import { getConfigurationValuesQuery } from "Tooling/modules/ToolingQueries";

import classes from "./WorkrampAcademy.scss";
import { WORKRAMP_ACADEMY_TYPE_CONFIG_ID } from "AddOnManager/routes/OrgAddOn/modules/OrgAddOnContants";
import { enableWorkrampAcademyForOrg } from "AddOnManager/routes/OrgAddOn/modules/OrgAddOnHelpers";

const DROPDOWN_OPTIONS = [
  {
    id: "us",
    label: "US",
    value: "US",
  },
  {
    id: "us",
    label: "EU",
    value: "EU",
  },
];

const WorkrampAcademy = props => {
  const {
    closeModal,
    isLoading,
    workrampAcademyDropdownValue,
    toggleSwitchValue,
    onSuccessAddOnConfigChange,
  } = props;

  const [selectedDropdownValue, setSelectedDropdownValue] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [disableDropdown, setDisableDropdown] = useState(false);
  const [showFullScreenLoading, setShowFullScreenLoading] = useState(false);

  useEffect(() => {
    if (!workrampAcademyDropdownValue) return;
    setDisableDropdown(true);
    setSelectedDropdownValue(workrampAcademyDropdownValue);
  }, [workrampAcademyDropdownValue]);

  useEffect(() => {
    setIsChecked(toggleSwitchValue);
  }, [toggleSwitchValue]);

  const handleToggleChange = e => {
    setIsChecked(e.target.checked);
  };

  const onSelectChange = e => {
    setSelectedDropdownValue(e);
  };

  const handleOnSave = async () => {
    const { enableWorkrampAcademyForOrg, orgId, orgRegion, addOn } = props;

    setShowFullScreenLoading(true);
    if (!disableDropdown && selectedDropdownValue) {
      const parameters = {
        valueType: "TEXT",
        entityType: "ORGANIZATION",
        configurationId: WORKRAMP_ACADEMY_TYPE_CONFIG_ID,
      };
      await enableWorkrampAcademyForOrg({
        orgId,
        orgRegion,
        addOnsParameters: addOn.addOnsParameters,
        dropdownQueryVariables: parameters,
        addOnId: addOn.id,
        value: selectedDropdownValue,
      });
    }
    await enableWorkrampAcademyForOrg({
      orgId,
      orgRegion,
      addOnsParameters: addOn.addOnsParameters,
      addOnId: addOn.id,
      value: isChecked,
    });
    if (!_.isNil(onSuccessAddOnConfigChange)) onSuccessAddOnConfigChange();
    setShowFullScreenLoading(false);
    closeModal();
  };

  return (
    <>
      <Modal width="600px" height="300px" isOpen onClose={closeModal}>
        {isLoading ? (
          <Loading />
        ) : (
          <div className={classes.modalBody}>
            <div className={classes.modalHeader}>
              <div className="heading-4">Workramp Academy</div>
              <IconButton
                icon={<CloseOutlined />}
                _legacy_variant="plain"
                variant="neutral"
                type="plain"
                onClick={closeModal}
              />
            </div>
            <div className={classes.modalContent}>
              <FormSelectDropdown
                size="medium"
                isSearchable={false}
                isClearable={false}
                placeholder="Select workramp academy"
                value={selectedDropdownValue}
                disabled={disableDropdown}
                options={DROPDOWN_OPTIONS}
                updateInputField={onSelectChange}
              />
              <div className={classes.toggleCardContainer}>
                <div className="text-body-1">Workramp Academy</div>
                <ToggleSwitch
                  checked={isChecked}
                  onChange={handleToggleChange}
                  disabled={!selectedDropdownValue}
                />
              </div>
            </div>
            <div className={classes.modalFooter}>
              <Button
                _legacy_variant="outlined-subtle"
                variant="neutral"
                type="outlined"
                onClick={closeModal}
              >
                Discard
              </Button>
              <Button
                variant="progressive"
                onClick={handleOnSave}
                disabled={!disableDropdown && !selectedDropdownValue}
              >
                Save
              </Button>
            </div>
          </div>
        )}
      </Modal>
      {showFullScreenLoading ? <FullScreenLoader /> : null}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { orgId, addOn } = ownProps;

  const toggleSwitchQueryFilter = {
    configurationIds: addOn.addOnsParameters.configurationId,
    searchText: orgId,
  };

  const dropdownQueryFilter = {
    configurationIds: WORKRAMP_ACADEMY_TYPE_CONFIG_ID,
    searchText: orgId,
  };

  return {
    dropdownQueryFilter,
    toggleSwitchQueryFilter,
  };
};

const mapActionCreators = {
  enableWorkrampAcademyForOrg,
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  graphql(getConfigurationValuesQuery, {
    name: "getConfigurationValuesQuery",
    options: ({ dropdownQueryFilter: filters }) => ({
      fetchPolicy: "cache-and-network",
      variables: { filters },
    }),
    props({ getConfigurationValuesQuery }) {
      const data = _.get(
        getConfigurationValuesQuery,
        "platform.getConfigurationValues.0.values",
        []
      );
      const workrampAcademyDropdownValue = _.get(_.head(data), "value", null);
      return {
        isLoading: _.includes(
          [1, 2],
          getConfigurationValuesQuery.networkStatus
        ),
        workrampAcademyDropdownValue,
      };
    },
  }),
  graphql(getConfigurationValuesQuery, {
    name: "getConfigurationValuesQuery",
    options: ({ toggleSwitchQueryFilter: filters }) => ({
      fetchPolicy: "cache-and-network",
      variables: { filters },
    }),
    props({ getConfigurationValuesQuery }) {
      const data = _.get(
        getConfigurationValuesQuery,
        "platform.getConfigurationValues.0.values",
        []
      );
      const isChecked = _.get(_.head(data), "value", false);
      return {
        isLoading: _.includes(
          [1, 2],
          getConfigurationValuesQuery.networkStatus
        ),
        toggleSwitchValue: isChecked === "true",
      };
    },
  })
)(WorkrampAcademy);
